//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "HourEncuesta",
  props: {
    value: {
      type: Number,
      default: 0
    },
    pregunta: String,
    min: Number,
    max: Number,
    bottom: String,
    top: String,
    readOnly: Boolean
  },
  data() {
    return {
      respuesta: this.value
    };
  },
  methods: {
    sendRespuesta(val) {
      this.respuesta = val;
      this.$emit("input", this.respuesta);
    },
    calculateHours(val) {
      if (val === 0) {
        return "Ninguna hora ";
      } else if (val === 0.5) {
        return "Media hora";
      } else if (val === 1) {
        return "Una hora";
      } else return `${val} horas`;
    }
  }
};
